export default "__VITE_ASSET__1ab0bb9d__"